import { INVENTORY_TYPES } from 'client/constants/inventory-types';

export function isCpo(type) {
  return type?.toUpperCase() === INVENTORY_TYPES.CPO;
}
